import moment from 'moment';
import { Directive, Input, OnChanges } from '@angular/core';

@Directive({ standalone: false })
export class UiDaysBeforeDeliveryComponent implements OnChanges {
  @Input() deliveryDate: string;

  public daysBeforeDelivery: number;

  constructor() {
  }

  ngOnChanges() {
    const _deliveryDate = moment(this.deliveryDate, 'YYYY-MM-DD').startOf('day');
    this.daysBeforeDelivery = _deliveryDate.diff(moment().startOf('day'), 'days');
  }

}
